import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const DrawerContext = createContext({
  scrollToBottom: () => {},
  isUserScrolledToBottom: false,
  onScroll: () => {},
  forceIsAtBottomCheck: () => {},
  scrollEl: null,
  drawerState: 'OPEN',
  setDrawerState: () => {},
  forceCloseForm: false,
});

export const DrawerProvider = ({ children }) => {
  const [forceCloseForm, setForceCloseForm] = useState(false);
  const [drawerState, setDrawerState] = useState('OPEN');
  const [isUserScrolledToBottom, setIsUserScrolledToBottom] = useState(false);
  const scrollEl = useRef(null);

  const scrollToBottom = (behavior = 'auto') => {
    if (scrollEl.current) {
      scrollEl.current.scrollTo({
        top: scrollEl.current.scrollHeight,
        behavior
      });
    }
  };

  const onScroll = (event) => {
    const drawerEl = event.target;
    // 20 is completely arbitrary, but gives a bit of margin some of the calculations.
    const isAtBottom = drawerEl.scrollHeight - drawerEl.scrollTop - drawerEl.clientHeight <= 20;
    setIsUserScrolledToBottom(isAtBottom);
  };

  const forceIsAtBottomCheck = () => {
    if (scrollEl.current) {
      const isAtBottom = scrollEl.current.scrollHeight
       - scrollEl.current.scrollTop - scrollEl.current.clientHeight <= 20;
      setIsUserScrolledToBottom(isAtBottom);
    }
  };

  useEffect(() => {
    // Handles initial load when there are not enough messages to cause drawer to scroll
    if (scrollEl.current) {
      const isScrollable = scrollEl.current.scrollHeight > scrollEl.current.clientHeight;
      setIsUserScrolledToBottom(!isScrollable);
    }
  }, []);

  useEffect(() => {
    const handleDrawerState = (IframeDrawerState) => {
      setDrawerState(IframeDrawerState?.output);
      if (IframeDrawerState?.output === 'MINIMIZED') {
        setForceCloseForm(true);
      } else {
        setForceCloseForm(false);
      }
    };

    if (typeof window !== 'undefined' && window.parent.LIFE_CYCLE_EVENT_BUS) {
      window.parent.LIFE_CYCLE_EVENT_BUS.on('magic-apron-assistant.drawer-minimize', handleDrawerState);

      return () => {
        window.parent.LIFE_CYCLE_EVENT_BUS.off('magic-apron-assistant.drawer-minimize', handleDrawerState);
      };
    }

    return () => {};
  }, []);

  const context = {
    scrollToBottom,
    isUserScrolledToBottom,
    onScroll,
    forceIsAtBottomCheck,
    scrollEl,
    drawerState,
    setDrawerState,
    forceCloseForm,
  };

  return (
    <DrawerContext.Provider value={context}>
      {children}
    </DrawerContext.Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDrawer = () => {
  return useContext(DrawerContext);
};
